// @ts-check
/** @typedef {import('../types/api').Discount} Discount */
/** @typedef {import('../types/api').PaginatedDiscounts} PaginatedDiscounts */
/** @typedef {import('../types/api').DiscountStats} DiscountStats */

import api from '../utils/apiClient';
import { assertShape } from '../utils/apiGuards';

const adminDiscountService = {
  /**
   * @param {Object} [params]
   * @returns {Promise<PaginatedDiscounts>}
   */
  getAllDiscounts: async ({ page = 1, limit = 50 } = {}) => {
    const data = await api.get(`/api/admin/discounts/?page=${page}&limit=${limit}`);
    assertShape(data, ['items', 'total'], 'adminDiscountService.getAllDiscounts');
    return data;
  },

  /**
   * @param {string} discountId
   * @returns {Promise<Discount>}
   */
  getDiscount: async (discountId) => {
    const data = await api.get(`/api/admin/discounts/${discountId}`);
    assertShape(data, ['id'], 'adminDiscountService.getDiscount');
    return data;
  },

  /**
   * @param {Object} discountData
   * @returns {Promise<Discount>}
   */
  createDiscount: async (discountData) => {
    return api.post('/api/admin/discounts/', discountData);
  },

  /**
   * @param {string} discountId
   * @param {Object} discountData
   * @returns {Promise<Discount>}
   */
  updateDiscount: async (discountId, discountData) => {
    return api.put(`/api/admin/discounts/${discountId}`, discountData);
  },

  /**
   * @param {string} discountId
   * @returns {Promise<void>}
   */
  deleteDiscount: async (discountId) => {
    return api.del(`/api/admin/discounts/${discountId}`);
  },

  /**
   * @returns {Promise<DiscountStats>}
   */
  getDiscountStats: async () => {
    const data = await api.get('/api/admin/discounts/stats/summary');
    assertShape(data, ['total_discounts'], 'adminDiscountService.getDiscountStats');
    return data;
  },
};

export default adminDiscountService;
